import {radialProgressiveBlur} from '@remotion/effects/radial-progressive-blur';
import {MacOSCursor} from '@remotion/mac-cursors';
import {Video} from '@remotion/media';
import {
	AbsoluteFill,
	Composition,
	Easing,
	HtmlInCanvas,
	interpolate,
	useCurrentFrame,
} from 'remotion';

export const CloseUp3Preview = () => {
	const frame = useCurrentFrame();
	const captureFrame = frame + 573;

	return (
		<HtmlInCanvas
			width={2014}
			height={2474}
			style={{
				width: 2014,
				height: 2474,
				translate: '-401.4px -240.9px',
				scale: 1.864,
				rotate: '0.985739 0.066606 -0.154536 58.502619deg',
				transformOrigin: '50% 0%',
			}}
			effects={[
				radialProgressiveBlur({
					center: [0.678, 0.345],
					height: 0.595,
					width: 0.716,
					endBlur: 13,
				}),
			]}
		>
			<AbsoluteFill name="Canvas Capture" style={{}} from={-573}>
				<Video
					src="https://remotion.media/studio-close-ups/studio-checker-editing.mp4"
					style={{
						position: 'absolute',
					}}
				/>
				<MacOSCursor
					cursor={interpolate(
						captureFrame,
						[
							75, 149, 153, 326, 327, 328, 338, 339, 341, 365, 366, 404, 406,
							439, 516, 604, 792, 793,
						],
						[
							'auto',
							'default',
							'auto',
							'default',
							'auto',
							'default',
							'row-resize',
							'default',
							'auto',
							'row-resize',
							'default',
							'auto',
							'default',
							'auto',
							'default',
							'auto',
							'row-resize',
							'auto',
						],
						{
							easing: Easing.step1,
							extrapolateLeft: 'clamp',
							extrapolateRight: 'clamp',
						},
					)}
					style={{
						position: 'absolute',
						left: 0,
						top: 0,
						scale: interpolate(
							captureFrame,
							[0, 182, 187, 222, 228, 286, 293, 421, 533, 581],
							[4, 3.6, 4, 3.6, 4, 3.6, 4, 3.6, 4, 3.6],
							{
								easing: Easing.step1,
								extrapolateLeft: 'clamp',
								extrapolateRight: 'clamp',
							},
						),
						translate: interpolate(
							captureFrame,
							[
								75, 76, 148, 149, 150, 151, 152, 153, 154, 155, 156, 157, 158,
								159, 160, 161, 162, 163, 164, 165, 166, 167, 168, 169, 170, 171,
								172, 173, 174, 175, 176, 177, 178, 179, 180, 181, 182, 183, 192,
								193, 194, 195, 196, 197, 198, 199, 200, 201, 202, 203, 204, 205,
								206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218,
								219, 220, 221, 222, 223, 236, 237, 269, 270, 271, 272, 273, 274,
								275, 276, 277, 278, 280, 281, 283, 284, 285, 321, 322, 323, 324,
								325, 326, 327, 328, 329, 330, 331, 334, 335, 336, 337, 338, 339,
								340, 341, 342, 343, 344, 345, 346, 347, 348, 349, 350, 351, 352,
								353, 354, 355, 356, 357, 358, 359, 360, 361, 362, 363, 364, 365,
								366, 367, 368, 369, 370, 371, 372, 373, 374, 375, 376, 377, 378,
								379, 380, 381, 382, 383, 384, 385, 386, 387, 388, 389, 390, 391,
								392, 393, 394, 395, 396, 397, 398, 399, 400, 401, 402, 403, 404,
								405, 406, 407, 408, 409, 410, 411, 412, 413, 414, 415, 416, 417,
								418, 419, 420, 426, 427, 428, 429, 430, 431, 432, 433, 434, 435,
								436, 437, 438, 439, 440, 441, 442, 443, 444, 445, 446, 447, 448,
								449, 450, 451, 452, 453, 454, 455, 456, 457, 458, 459, 460, 461,
								462, 463, 464, 465, 466, 467, 468, 469, 470, 471, 472, 473, 474,
								475, 476, 477, 478, 479, 480, 481, 482, 483, 484, 485, 486, 487,
								488, 489, 490, 491, 492, 493, 494, 495, 496, 497, 498, 499, 500,
								501, 502, 503, 504, 505, 506, 507, 508, 509, 510, 511, 512, 513,
								514, 515, 516, 517, 518, 519, 520, 521, 522, 523, 524, 525, 526,
								527, 528, 529, 530, 531, 532, 533, 534, 593, 594, 595, 596, 597,
								598, 599, 600, 601, 602, 603, 604, 605, 606, 607, 608, 609, 610,
								611, 612, 613, 614, 615, 616, 617, 618, 619, 620, 621, 622, 623,
								624, 625, 626, 627, 628, 629, 630, 631, 632, 633, 634, 635, 636,
								637, 638, 639, 640, 641, 642, 643, 644, 645, 646, 647, 648, 649,
							],
							[
								'0px 1204px',
								'0px 1204px',
								'0px 1204px',
								'289.53125px 412.421875px',
								'402.578125px 823.125px',
								'530.859375px 1336.28125px',
								'576.109375px 1660.546875px',
								'595.640625px 1954.828125px',
								'595.640625px 2066.109375px',
								'595.640625px 2233.953125px',
								'584.421875px 2334.109375px',
								'575.578125px 2388.25px',
								'563.46875px 2427.734375px',
								'560.78125px 2448.75px',
								'558.09375px 2460.96875px',
								'555.40625px 2473.1875px',
								'552.140625px 2507.203125px',
								'545.03125px 2539.359375px',
								'537.921875px 2571.515625px',
								'530.234375px 2609.828125px',
								'523.125px 2641.984375px',
								'511.609375px 2680.296875px',
								'505.078125px 2706.296875px',
								'500.28125px 2718.515625px',
								'496.640625px 2724.234375px',
								'495.109375px 2727.265625px',
								'495.109375px 2728.78125px',
								'495.109375px 2728.78125px',
								'494.03125px 2720.75px',
								'487.5px 2693.546875px',
								'487.5px 2654.03125px',
								'487.5px 2615.6875px',
								'487.5px 2577.34375px',
								'487.5px 2561.28125px',
								'487.5px 2552.84375px',
								'487.5px 2549.78125px',
								'487.5px 2549.78125px',
								'487.5px 2549.125px',
								'487.5px 2549.125px',
								'487.5px 2536.8125px',
								'481.546875px 2513.421875px',
								'471.546875px 2470.390625px',
								'468.28125px 2444.359375px',
								'468.28125px 2435.921875px',
								'468.28125px 2430.171875px',
								'468.28125px 2427.109375px',
								'468.28125px 2425.84375px',
								'468.28125px 2420.09375px',
								'468.28125px 2414.34375px',
								'465.59375px 2398.28125px',
								'461.375px 2389.84375px',
								'459.265625px 2376.0625px',
								'457.15625px 2367.625px',
								'455.625px 2364.5625px',
								'454.09375px 2358.8125px',
								'454.09375px 2350.375px',
								'449.296875px 2338.125px',
								'446.609375px 2322.0625px',
								'443.921875px 2306px',
								'441.8125px 2297.5625px',
								'439.703125px 2293.34375px',
								'438.171875px 2288.75px',
								'438.171875px 2285.953125px',
								'438.171875px 2285.953125px',
								'436.921875px 2284.703125px',
								'436.921875px 2283.546875px',
								'436.921875px 2282.28125px',
								'436.921875px 2280.75px',
								'436.921875px 2280.75px',
								'436.921875px 2280.15625px',
								'436.921875px 2280.15625px',
								'436.921875px 2274.890625px',
								'436.921875px 2274.890625px',
								'434.921875px 2278.859375px',
								'389.921875px 2338.828125px',
								'370.75px 2377.140625px',
								'367.484375px 2403.140625px',
								'367.484375px 2415.359375px',
								'367.484375px 2421.078125px',
								'367.484375px 2430.609375px',
								'367.484375px 2436.328125px',
								'367.484375px 2437.84375px',
								'367.484375px 2437.84375px',
								'367.484375px 2438.859375px',
								'367.484375px 2438.859375px',
								'366.40625px 2438.859375px',
								'365.140625px 2440.375px',
								'365.140625px 2440.375px',
								'365.140625px 2419.25px',
								'369.546875px 2373.578125px',
								'389.515625px 2303.578125px',
								'431.890625px 2154.859375px',
								'481.640625px 2006.140625px',
								'503.375px 1926.4375px',
								'528.953125px 1855.234375px',
								'538.125px 1828.03125px',
								'542.3125px 1818.46875px',
								'543.828125px 1815.40625px',
								'543.828125px 1815.40625px',
								'541.140625px 1824.453125px',
								'529.265625px 1845.46875px',
								'509.5px 1884.953125px',
								'487.40625px 1937.921875px',
								'467.40625px 2007.890625px',
								'448.5625px 2062.03125px',
								'438.5625px 2097.015625px',
								'425.296875px 2149.984375px',
								'409.34375px 2208.625px',
								'402.8125px 2234.625px',
								'398.015625px 2246.84375px',
								'396.484375px 2252.5625px',
								'396.484375px 2255.59375px',
								'394.953125px 2258.625px',
								'394.953125px 2260.140625px',
								'394.953125px 2261.234375px',
								'394.953125px 2264.265625px',
								'394.953125px 2267.296875px',
								'394.953125px 2268.8125px',
								'394.953125px 2285.234375px',
								'392.265625px 2301.265625px',
								'389.578125px 2317.296875px',
								'387.46875px 2329.515625px',
								'382.671875px 2341.734375px',
								'381.140625px 2347.453125px',
								'379.609375px 2350.484375px',
								'379.609375px 2352px',
								'376.8125px 2352px',
								'373.546875px 2312.484375px',
								'359.390625px 2163.765625px',
								'351.421875px 1939.921875px',
								'351.421875px 1597.390625px',
								'351.421875px 1552.6875px',
								'351.421875px 1552.6875px',
								'351.421875px 1275.828125px',
								'351.421875px 1236.3125px',
								'351.421875px 1219.078125px',
								'351.421875px 1213.59375px',
								'351.421875px 1213.59375px',
								'338.75px 1213.59375px',
								'322.6875px 1213.59375px',
								'306.625px 1218.9375px',
								'294.375px 1223.703125px',
								'291.3125px 1226.734375px',
								'282.875px 1226.734375px',
								'278.078125px 1213.71875px',
								'265.390625px 1168.046875px',
								'256.546875px 1113.875px',
								'242.703125px 1052.375px',
								'233.28125px 990.875px',
								'229.4375px 952.53125px',
								'226.171875px 931.078125px',
								'224.0625px 926.859375px',
								'224.0625px 925.59375px',
								'221.265625px 925.59375px',
								'219.734375px 925.59375px',
								'218.46875px 925.59375px',
								'216.9375px 925.59375px',
								'215.78125px 925.59375px',
								'212.703125px 920.96875px',
								'212.703125px 908.71875px',
								'210.015625px 892.65625px',
								'207.328125px 876.59375px',
								'207.328125px 864.34375px',
								'207.328125px 858.59375px',
								'207.328125px 857.0625px',
								'207.328125px 855.796875px',
								'207.328125px 853.109375px',
								'207.328125px 853.109375px',
								'207.328125px 850.578125px',
								'207.328125px 850.578125px',
								'207.328125px 847.78125px',
								'207.328125px 837.8125px',
								'207.328125px 829.375px',
								'207.328125px 823.625px',
								'207.328125px 817.875px',
								'207.328125px 814.8125px',
								'207.328125px 811.75px',
								'207.328125px 808.6875px',
								'208.84375px 807.15625px',
								'208.84375px 805.890625px',
								'208.84375px 803.09375px',
								'208.84375px 803.09375px',
								'208.84375px 801.828125px',
								'208.84375px 800.671875px',
								'208.84375px 799.40625px',
								'208.84375px 799.40625px',
								'216.265625px 799.40625px',
								'216px 796px',
								'304px 796px',
								'456px 796px',
								'544px 796px',
								'620px 796px',
								'684px 796px',
								'724px 796px',
								'744px 796px',
								'752px 796px',
								'752px 796px',
								'756px 796px',
								'780px 796px',
								'816px 784px',
								'872px 768px',
								'908px 756px',
								'956px 740px',
								'996px 728px',
								'1036px 720px',
								'1064px 712px',
								'1088px 708px',
								'1112px 708px',
								'1128px 708px',
								'1144px 708px',
								'1160px 708px',
								'1180px 708px',
								'1196px 712px',
								'1216px 720px',
								'1232px 728px',
								'1256px 740px',
								'1272px 748px',
								'1288px 760px',
								'1300px 768px',
								'1308px 772px',
								'1312px 776px',
								'1312px 780px',
								'1316px 780px',
								'1316px 780px',
								'1316px 780px',
								'1316px 780px',
								'1316px 780px',
								'1316px 780px',
								'1316px 780px',
								'1316px 780px',
								'1316px 780px',
								'1316px 780px',
								'1316px 780px',
								'1316px 780px',
								'1316px 780px',
								'1316px 780px',
								'1316px 780px',
								'1316px 780px',
								'1316px 780px',
								'1316px 780px',
								'1316px 780px',
								'1316px 780px',
								'1316px 780px',
								'1316px 780px',
								'1316px 780px',
								'1316px 780px',
								'1316px 780px',
								'1320px 780px',
								'1320px 780px',
								'1320px 780px',
								'1320px 780px',
								'1320px 780px',
								'1320px 780px',
								'1320px 780px',
								'1320px 780px',
								'1320px 780px',
								'1320px 780px',
								'1316px 780px',
								'1308px 780px',
								'1300px 780px',
								'1272px 780px',
								'1244px 784px',
								'1204px 792px',
								'1152px 800px',
								'1112px 808px',
								'1048px 820px',
								'992px 832px',
								'932px 840px',
								'848px 848px',
								'744px 852px',
								'628px 852px',
								'548px 852px',
								'432px 852px',
								'376px 852px',
								'336px 852px',
								'284px 836px',
								'244px 820px',
								'216px 804px',
								'196px 796px',
								'188px 792px',
								'184px 792px',
								'184px 788px',
								'184px 788px',
								'184px 788px',
								'184px 788px',
								'184px 788px',
								'184px 788px',
								'184px 788px',
								'184px 788px',
								'184px 788px',
								'184px 788px',
								'184px 788px',
								'184.578125px 788.328125px',
								'184.578125px 789.328125px',
								'184.578125px 789.328125px',
								'186.515625px 789.328125px',
								'199.703125px 789.328125px',
								'284px 788px',
								'328px 788px',
								'416px 788px',
								'496px 788px',
								'592px 788px',
								'672px 800px',
								'712px 804px',
								'768px 812px',
								'820px 816px',
								'860px 820px',
								'908px 824px',
								'924px 824px',
								'948px 824px',
								'976px 824px',
								'1000px 824px',
								'1020px 824px',
								'1056px 824px',
								'1072px 824px',
								'1100px 824px',
								'1124px 824px',
								'1148px 824px',
								'1168px 824px',
								'1192px 824px',
								'1212px 824px',
								'1228px 824px',
								'1244px 824px',
								'1256px 824px',
								'1268px 824px',
								'1272px 824px',
								'1276px 824px',
								'1284px 824px',
								'1288px 824px',
								'1296px 824px',
								'1304px 824px',
								'1316px 824px',
								'1328px 824px',
								'1340px 824px',
								'1348px 828px',
								'1356px 828px',
								'1356px 828px',
								'1360px 828px',
								'1360px 828px',
								'1360px 828px',
								'1360px 828px',
								'1364px 828px',
								'1364px 828px',
								'1364px 828px',
								'1364px 828px',
								'1364px 828px',
								'1364px 828px',
								'1364px 828px',
								'1364px 828px',
								'1364px 828px',
								'1364px 828px',
							],
							{
								extrapolateLeft: 'clamp',
								extrapolateRight: 'clamp',
							},
						),
					}}
				/>
			</AbsoluteFill>
		</HtmlInCanvas>
	);
};

export const CloseUp3 = () => {
	return (
		<Composition
			id="DragOntoCanvas"
			component={CloseUp3Preview}
			width={1920}
			height={1080}
			fps={60}
			durationInFrames={76}
		/>
	);
};
